import gsap from 'gsap';
import Sniffer from 'sniffer';

export default class Team {
  constructor() {
    this.page = document.querySelector('.p-about');
    this.section = document.querySelector('.s-team');

    this.targetX = 0;
    this.targetY = 0;

    this.currentX = 0;
    this.currentY = 0;

    this.ease = 0.05;

    this.list = document.querySelector('.s-team-list');
    this.rows = document.querySelectorAll('.s-team-row');
    this.categories = document.querySelectorAll('.s-team-category');
    this.rowHeight = document.querySelector('.s-team-row').clientHeight;

    this.names = document.querySelectorAll('.s-team-list .s-team-col');
    this.indicators = document.querySelectorAll('.s-team-indicator');

    this.pointer = {
      dot: document.querySelector('.a-pointer-dot'),
      label: document.querySelector('.a-pointer-label'),
    };

    this.loading = false;

    this.filter(this.categories[0]);
  }

  transform = () => {
    this.currentX += ((this.targetX - this.currentX) * this.ease);
    this.currentY += ((this.targetY - this.currentY) * this.ease);

    this.image.style.transform = `translate3d(${this.currentX}px, ${this.currentY}px, 0)`;
  }

  setHeight = () => {
    this.page = document.querySelector('.a-scroll > div');
    document.body.style.height = `${this.page.offsetHeight}px`;
  }

  mouseMove = (e) => {
    this.targetX = e.clientX - this.image.clientWidth / 2;
    this.targetY = e.clientY - this.image.clientHeight / 2;
  }

  listEnter = () => {
    this.pointer.label.innerHTML = 'Explore';

    const tl = gsap.timeline({
      defaults: {
        duration: 0.25,
      },
    });

    tl
      .to(this.pointer.dot, {
        opacity: 0,
      }, 0)

      .to(this.pointer.label, {
        opacity: 1,
      }, 0)

      .to(this.image, {
        opacity: 1,
      }, 0);
  }

  listLeave = () => {
    this.pointer.label.innerHTML = '';

    const tl = gsap.timeline({
      defaults: {
        duration: 0.25,
      },
    });

    tl
      .to(this.pointer.dot, {
        opacity: 1,
      }, 0)

      .to(this.pointer.label, {
        opacity: 0,
      }, 0);

    if (this.loading === true) return;

    tl
      .to(this.image, {
        opacity: 0,
      }, 0);
  }

  rowEnter = (el) => {
    const name = el.querySelectorAll('.s-team-col');
    const indicator = el.querySelector('.s-team-indicator');

    const tl = gsap.timeline({
      defaults: {
        duration: 0.5,
      },
    });

    tl
      .to(this.names, {
        opacity: 0.2,
      }, 0)
      .to(this.indicators, {
        scaleX: 0,
        transformOrigin: 'right',
      }, 0)
      .to(name, {
        opacity: 1,
      }, 0)
      .to(indicator, {
        scaleX: 1,
        transformOrigin: 'left',
      }, 0);
  }

  rowLeave = () => {
    if (this.loading === true) return;

    const tl = gsap.timeline({
      defaults: {
        duration: 0.5,
      },
    });

    tl
      .to(this.names, {
        opacity: 1,
      }, 0)
      .to(this.indicators, {
        scaleX: 0,
        transformOrigin: 'right',
      }, 0);
  }

  filter = (el) => {
    this.category = el.dataset.type;

    this.filtered = document.querySelectorAll(`.s-team-row[data-type='${this.category}']`);
    this.height = (this.filtered.length + 1) * this.rowHeight + 20;

    if (el.dataset.type === 'all') {
      this.filtered = document.querySelectorAll('.s-team-row');
      this.height = this.rows.length * this.rowHeight;
    }

    let display;

    if (Sniffer.isPhone) {
      display = 'block';
    } else {
      display = 'flex';
    }

    const tl = gsap.timeline({
      onComplete: this.setHeight,
    });

    tl
      .to(this.categories, {
        opacity: 0.5,
        duration: 0.5,
      }, 0)

      .to(el, {
        opacity: 1,
        duration: 0.5,
      }, 0)

      .to(this.rows, {
        opacity: 0,
        duration: 0.5,
      }, 0)

      .to(this.list, {
        height: this.height,
        ease: 'expo.inOut',
        duration: 1.5,
      }, 0)

      .set(this.rows, {
        display: 'none',
      }, 0.7)

      .set(this.filtered, {
        display,
      }, 0.7)

      .to(this.filtered, {
        opacity: 1,
        duration: 0.5,
      }, 0.7);
  }

  addEvents = () => {
    // window.addEventListener('mousemove', this.mouseMove, { passive: true });

    [...this.categories].forEach((el) => {
      el.addEventListener('click', () => this.filter(el));
    });

    // this.list.addEventListener('mouseenter', this.listEnter);
    // this.list.addEventListener('mouseleave', this.listLeave);

    [...this.rows].forEach((el) => {
      el.addEventListener('click', this.destroy);
      el.addEventListener('mouseenter', () => {
        this.rowEnter(el);
      });
      el.addEventListener('mouseleave', () => {
        this.rowLeave(el);
      });
    });
  }

  removeEvents = () => {
    window.removeEventListener('mousemove', this.mouseMove);

    this.list.removeEventListener('mouseenter', this.listEnter);
    this.list.removeEventListener('mouseleave', this.listLeave);

    [...this.rows].forEach((el) => {
      el.removeEventListener('click', this.destroy);
      el.removeEventListener('mouseenter', () => {
        this.rowEnter(el);
      });
      el.removeEventListener('mouseleave', () => {
        this.rowLeave(el);
      });
    });
  }

  create = () => {
    this.container = document.createElement('div');
    this.container.classList.add('a-scene');

    this.image = document.createElement('div');
    this.image.classList.add('a-scene-image');

    this.container.appendChild(this.image);

    document.querySelector('.a-main').appendChild(this.container);
  }

  destroy = () => {
    this.loading = true;
    this.removeEvents();
    this.listLeave();
    // gsap.ticker.remove(this.transform);
  }

  init = () => {
    // this.create();
    this.addEvents();

    // gsap.ticker.add(this.transform);
  }
}
